export default {
  methods: {
    // 标题按钮
    iconShow(val = 0) {
      if (val == this.btnIndex) {
        return "el-icon-minus";
      } else {
        return "el-icon-plus";
      }
    },
    // 板块是否展开
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
    // 点击标题
    handleIndex(index) {
      this.activeNames = 0;
      this.activeNames1 = 0;
      this.activeNames2 = 0;
      this.activeNames3 = 0;
      if (this.btnIndex === index) {
        this.btnIndex = -1;
      } else {
        this.btnIndex = index;
      }
    },
  },
};
